export default "__VITE_ASSET__AmEF6ru4__"